import styled from 'styled-components';

export const LineItemsEditButtonsStyled = styled.div`
  .lineItemsEditButtons {
    &__editButtons {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
    }

    &__container {
      align-items: flex-start;
      border-top: 1px solid ${props => props.theme.uiColors.componentSpacerDefault};
      display: flex;
      flex-direction: column;
    }

    &__button i {
      font-size: 0.75rem;
    }
  }
`;
